import { Directive, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[dateInput]'
})
export class DateInputDirective {
  lastValue: string;

  constructor(@Self() private ngControl: NgControl) {
    this.ngControl.valueChanges.subscribe((value: string) => {
      if(value == null || value.match(/^([0-1]?$|0[1-9]|1[012])(\/($|[0-3]$|0[1-9]|[12][0-9]|3[01])(\/[0-9]{0,4})?)?$/) != null)
        this.lastValue = value;
      else
        this.ngControl.control.setValue(this.lastValue);
    });
  }
}